import './SectionHeading.css'

const SectionHeading = () => {

  return (
    <div className="section-heading text-center">
        <h2 className="title-head-subscribe" data-aos="fade-up">Don’t Miss Green Earth Metaverse News And Updates!</h2>
        <p className="text-head-subscribe" data-aos="fade-up">Join our telegram and get involved in our communities to keep upto date about all things Green Earth Metaverse.</p>
    </div>
  );
}

export default SectionHeading;